import { useState } from "react";
import { Layers } from "lucide-react";

export const BASES = [
  { k: "dark", label: "Callejero oscuro" },
  { k: "light", label: "Callejero claro" },
  { k: "pnoa", label: "Satélite PNOA (IGN)" },
];

export const GROUPS = [
  { k: "route", label: "Recorrido" },
  { k: "cuts", label: "Cortes y tramos" },
  { k: "autocuts", label: "Cortes previos" },
  { k: "no_parking", label: "Prohibido estacionar" },
  { k: "special", label: "Zonas especiales y sentidos invertidos" },
  { k: "signs", label: "Señales, vallas y conos" },
  { k: "detours", label: "Desvíos" },
  { k: "staff", label: "Personal (Policía, P. Civil, voluntarios)" },
];

export const groupOf = (el) =>
  el.auto_generated ? "autocuts"
    : el.kind === "cut_point" || el.kind === "street_cut" ? "cuts"
      : el.kind === "special_path" || el.kind === "reversed_oneway" ? "special"
        : el.kind === "sign" ? "signs" : el.kind;

export const MapLayersPanel = ({ base, setBase, hidden, setHidden }) => {
  const [open, setOpen] = useState(false);
  const toggle = (k) => setHidden((h) => (h.includes(k) ? h.filter((x) => x !== k) : [...h, k]));
  return (
    <div className="flex flex-col items-end gap-1">
      <button onClick={() => setOpen((v) => !v)} data-testid="map-layers-button"
        className={`flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-medium border backdrop-blur-md transition-colors ${open ? "bg-sky-500 text-slate-950 border-sky-400" : "bg-[#090f20]/90 text-slate-300 border-white/10 hover:bg-white/10"}`}>
        <Layers className="w-4 h-4" /> Capas
      </button>
      {open && (
        <div className="w-60 bg-[#090f20]/95 backdrop-blur-md border border-white/10 rounded-xl p-3 space-y-3 rise" data-testid="map-layers-panel">
          <div>
            <div className="font-mono text-[10px] tracking-widest text-slate-500 mb-1.5">MAPA BASE</div>
            {BASES.map((b) => (
              <label key={b.k} className="flex items-center gap-2 py-1 text-xs text-slate-200 cursor-pointer">
                <input type="radio" name="basemap" checked={base === b.k} onChange={() => setBase(b.k)} className="accent-sky-500" data-testid={`map-base-${b.k}`} />{b.label}
              </label>
            ))}
          </div>
          <div>
            <div className="font-mono text-[10px] tracking-widest text-slate-500 mb-1.5">ELEMENTOS</div>
            {GROUPS.map((g) => (
              <label key={g.k} className="flex items-center gap-2 py-1 text-xs text-slate-200 cursor-pointer">
                <input type="checkbox" checked={!hidden.includes(g.k)} onChange={() => toggle(g.k)} className="accent-sky-500" data-testid={`map-layer-${g.k}`} />{g.label}
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
